import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { MdAdd, MdClose, MdDelete, MdEdit, MdLocationOn, MdPersonSearch } from "react-icons/md";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { ConfirmDeleteDialog, InfoDialog, Loader, ScrollToTop, SearchBar } from "../../../components";
import { ShowTableDaftarKunjungan } from "../../../components/ShowTable";

const TampilDaftarKunjungan = () => {
  const { user, dispatch } = useContext(AuthContext);
  const { screenSize } = useStateContext();
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.pathname.split("/")[2];

  const [isDaftarKunjunganExist, setIsDaftarKunjunganExist] = useState(false);
  const [daftarKunjunganData, setDaftarKunjunganData] = useState(null);
  const [daftarKunjungansData, setDaftarKunjungansData] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleteError, setDeleteError] = useState("");
  let [page, setPage] = useState(0);
  const [limit] = useState(20);
  const [pages, setPages] = useState(0);
  const [query, setQuery] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedKolektor, setSelectedKolektor] = useState(null);
  const [kolektors, setKolektors] = useState([]);
  const [openKolektor, setOpenKolektor] = useState(false);
  const [pageKolektor, setPageKolektor] = useState(0);
  const [limitKolektor] = useState(10);
  const [pagesKolektor, setPagesKolektor] = useState(0);
  const [queryKolektor, setQueryKolektor] = useState("");
  const [searchTermKolektor, setSearchTermKolektor] = useState("");
  const [loadingKolektor, setLoadingKolektor] = useState(false);
  const isKolektorUser = ["KOLEKTOR", "EKS"].includes((user?.tipeUser || "").toUpperCase());

  useEffect(() => {
    id ? getDaftarKunjunganById() : setIsDaftarKunjunganExist(false);
  }, [id]);

  useEffect(() => {
    getDaftarKunjungans();
  }, [page, searchTerm, selectedKolektor]);

  useEffect(() => {
    if (openKolektor) {
      getKolektors();
    }
  }, [openKolektor, pageKolektor, searchTermKolektor]);

  const getPhotoUrl = (photo) => (typeof photo === "string" ? photo : photo?.url);
  const getPhotoLocation = (photo) => {
    if (typeof photo === "string" || photo?.latitude == null || photo?.longitude == null) return null;
    return photo;
  };
  const formatCapturedAt = (capturedAt) => {
    if (!capturedAt) return "-";
    return new Intl.DateTimeFormat("id-ID", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }).format(new Date(capturedAt));
  };
  const getGoogleMapsUrl = (photoLocation) => `https://www.google.com/maps?q=${photoLocation.latitude},${photoLocation.longitude}`;
  const formatSourceType = (value) => {
    if (value === "ENTRY PERMOHONAN") return "DAFTAR PERMOHONAN";
    if (value === "ADMIN VERIFIKATOR") return "VALIDASI DATA VERIFIKATOR";
    return value || "-";
  };
  const getMapEmbedUrl = (photoLocation) => {
    const latitude = Number(photoLocation.latitude);
    const longitude = Number(photoLocation.longitude);
    const delta = 0.004;
    return `https://www.openstreetmap.org/export/embed.html?bbox=${longitude - delta}%2C${latitude - delta}%2C${longitude + delta}%2C${latitude + delta}&layer=mapnik&marker=${latitude}%2C${longitude}`;
  };

  const lastLocatedPhoto = (daftarKunjunganData?.fotoKunjungan || [])
    .map((photo) => ({ photo, location: getPhotoLocation(photo) }))
    .filter((item) => item.location)
    .sort((a, b) => new Date(a.location.capturedAt || 0) - new Date(b.location.capturedAt || 0))
    .pop();

  const handleAuthError = (err) => {
    if (err.response?.status === 401) {
      dispatch({ type: "LOGOUT" });
      navigate("/");
    }
  };

  const handleChange = (e, p) => setPage(p - 1);
  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTerm(query);
  };

  const getDaftarKunjungans = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${tempUrl}/daftarKunjungansPagination?kolektor_id=${selectedKolektor?._id || ""}&search_query=${encodeURIComponent(searchTerm)}&page=${page}&limit=${limit}`,
        { id: user._id, token: user.token },
      );
      setQuery(searchTerm);
      setDaftarKunjungansData(response.data.daftarKunjungans);
      setPage(response.data.page);
      setPages(response.data.totalPage);
    } catch (err) {
      handleAuthError(err);
      setError(err.response?.data?.message || "Gagal mengambil data daftar kunjungan.");
    }
    setLoading(false);
  };

  const getKolektors = async () => {
    setLoadingKolektor(true);
    try {
      const response = await axios.post(
        `${tempUrl}/kolektorsAllCabangPagination?search_query=${encodeURIComponent(searchTermKolektor)}&page=${pageKolektor}&limit=${limitKolektor}`,
        { id: user._id, token: user.token },
      );
      setQueryKolektor(searchTermKolektor);
      setKolektors(response.data.kolektors);
      setPageKolektor(response.data.page);
      setPagesKolektor(response.data.totalPage);
    } catch (err) {
      handleAuthError(err);
      setError(err.response?.data?.message || "Gagal mengambil data kolektor.");
    }
    setLoadingKolektor(false);
  };

  const searchKolektor = (event) => {
    event.preventDefault();
    setPageKolektor(0);
    setSearchTermKolektor(queryKolektor);
  };

  const selectKolektor = (kolektor) => {
    setSelectedKolektor(kolektor);
    setPage(0);
    setOpenKolektor(false);
  };

  const clearKolektorFilter = () => {
    setSelectedKolektor(null);
    setPage(0);
  };

  const getDaftarKunjunganById = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${tempUrl}/daftarKunjungans/${id}`, {
        id: user._id,
        token: user.token,
      });
      setIsDaftarKunjunganExist(true);
      setDaftarKunjunganData(response.data);
    } catch (err) {
      handleAuthError(err);
      setError(err.response?.data?.message || "Gagal mengambil detail daftar kunjungan.");
    }
    setLoading(false);
  };

  const deleteDaftarKunjungan = async () => {
    setShowDeleteConfirm(false);
    setLoading(true);
    try {
      await axios.post(`${tempUrl}/deleteDaftarKunjungan/${id}`, { id: user._id, token: user.token });
      navigate("/daftarKunjungan");
      await getDaftarKunjungans();
    } catch (err) {
      handleAuthError(err);
      setDeleteError(err.response?.data?.message || "Gagal menghapus daftar kunjungan.");
      setLoading(false);
    }
  };

  const renderMapLastLocation = () => {
    if (!lastLocatedPhoto) return null;
    return (
      <section className="section-panel">
        <div className="toolbar mt-0">
          <div>
            <h2 className="h6 fw-bold mb-1">Lokasi Foto Terakhir</h2>
            <div className="text-muted">
              Foto Kunjungan
              {lastLocatedPhoto.location.accuracy ? ` - Akurasi ${Math.round(lastLocatedPhoto.location.accuracy)} meter` : ""}
            </div>
          </div>
          <Button className="btn-icon" size="sm" variant="outline-primary" onClick={() => window.open(getGoogleMapsUrl(lastLocatedPhoto.location), "_blank", "noopener,noreferrer")}>
            <MdLocationOn /> Google Maps
          </Button>
        </div>
        <div className="map-preview mt-3">
          <iframe title="Lokasi Foto Terakhir" src={getMapEmbedUrl(lastLocatedPhoto.location)} loading="lazy" />
        </div>
      </section>
    );
  };

  const renderFotoKunjungan = () => (
    <section className="section-panel mt-3">
      <h2 className="h6 fw-bold mb-3">Foto Kunjungan</h2>
      {(daftarKunjunganData?.fotoKunjungan || []).length === 0 && <div className="text-muted">Belum ada foto.</div>}
      <div className="photo-grid">
        {(daftarKunjunganData?.fotoKunjungan || []).map((img, i) => {
          const photoUrl = getPhotoUrl(img);
          const photoLocation = getPhotoLocation(img);
          return (
            <div className="photo-card" key={`foto-kunjungan-${i}`}>
              <button type="button" onClick={() => window.open(photoUrl, "_blank", "noopener,noreferrer")}>
                <img src={photoUrl} alt={`Foto Kunjungan ${i + 1}`} />
                <span>No. {i + 1}</span>
              </button>
              <div className="photo-meta">
                <div>
                  <strong>Waktu</strong>
                  <span>{formatCapturedAt(img?.capturedAt)}</span>
                </div>
              </div>
              {photoLocation && (
                <Button className="photo-map-btn" size="sm" variant="outline-primary" type="button" onClick={() => window.open(getGoogleMapsUrl(photoLocation), "_blank", "noopener,noreferrer")}>
                  <MdLocationOn /> Lihat Maps
                </Button>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );

  if (loading) return <Loader />;

  return (
    <div>
      <ScrollToTop />
      <div className="page-header">
        <div>
          <div className="page-kicker">Survey</div>
          <h1 className="page-title">Daftar Kunjungan</h1>
        </div>
        <Button className="btn-icon" size="sm" onClick={() => navigate("/daftarKunjungan/tambahDaftarKunjungan")}>
          <MdAdd /> Tambah
        </Button>
      </div>
      {error && <Alert variant="warning">{error}</Alert>}

      {isDaftarKunjunganExist && daftarKunjunganData && (
        <>
          <section className="section-panel">
            <div className="toolbar mt-0">
              <div className="detail-title-actions">
                <Button className="btn-back" size="sm" variant="outline-secondary" onClick={() => navigate("/daftarKunjungan")}>
                  {"< Kembali"}
                </Button>
                <div>
                  <h2 className="h6 fw-bold mb-1">Detail Daftar Kunjungan</h2>
                  <div className="text-muted">{daftarKunjunganData.optionNamaPemohon}</div>
                </div>
              </div>
              {!isKolektorUser && (
                <div className="d-flex gap-2 flex-wrap">
                  <Button className="btn-icon" size="sm" variant="outline-primary" onClick={() => navigate(`/daftarKunjungan/${id}/edit`)}>
                    <MdEdit /> Ubah
                  </Button>
                  <Button className="btn-icon" size="sm" variant="outline-danger" onClick={() => setShowDeleteConfirm(true)}>
                    <MdDelete /> Hapus
                  </Button>
                </div>
              )}
            </div>
            {isKolektorUser && (
              <Alert variant="info" className="mt-3 mb-0">
                Tipe User KOLEKTOR tidak bisa mengubah atau menghapus Daftar Kunjungan yang sudah tersimpan.
              </Alert>
            )}
            <hr />
            <Row>
              <Col md={6}>
                <div className="mb-3"><div className="detail-label">Nama Pemohon</div><div className="detail-value">{daftarKunjunganData.optionNamaPemohon || "-"}</div></div>
                <div className="mb-3"><div className="detail-label">Alamat</div><div className="detail-value">{daftarKunjunganData.optionAlamat || "-"}</div></div>
                <div className="mb-3"><div className="detail-label">No Jual</div><div className="detail-value">{daftarKunjunganData.optionNoJual || "-"}</div></div>
                <div className="mb-3"><div className="detail-label">Nopol</div><div className="detail-value">{daftarKunjunganData.optionNopol || "-"}</div></div>
              </Col>
              <Col md={6}>
                <div className="mb-3"><div className="detail-label">Sumber</div><div className="detail-value">{formatSourceType(daftarKunjunganData.sourceType)}</div></div>
                <div className="mb-3"><div className="detail-label">Kolektor</div><div className="detail-value">{daftarKunjunganData.userId?.kodeKolektor?.kodeKolektor ? `${daftarKunjunganData.userId.kodeKolektor.kodeKolektor} - ${daftarKunjunganData.userId.kodeKolektor.namaKolektor}` : daftarKunjunganData.userId?.username || "-"}</div></div>
                <div className="mb-3"><div className="detail-label">Tanggal Kunjungan</div><div className="detail-value">{daftarKunjunganData.tanggalKunjungan ? new Date(daftarKunjunganData.tanggalKunjungan).toLocaleDateString("id-ID") : "-"}</div></div>
                <div className="mb-3"><div className="detail-label">Alasan Kolektor</div><div className="detail-value">{daftarKunjunganData.alasanKolektor || "-"}</div></div>
              </Col>
            </Row>
          </section>
          {renderMapLastLocation()}
          {renderFotoKunjungan()}
        </>
      )}

      <section className="section-panel">
        <Row>
          <Col lg={{ span: 6, offset: 6 }}>
            <Form.Group className="mb-3">
              <Form.Label className="detail-label">Filter Kolektor</Form.Label>
              <div className="filter-picker">
                <Form.Control
                  value={
                    selectedKolektor
                      ? `${selectedKolektor.kodeKolektor} - ${selectedKolektor.namaKolektor}`
                      : ""
                  }
                  placeholder="SEMUA KOLEKTOR"
                  readOnly
                  onClick={() => setOpenKolektor(true)}
                />
                <Button
                  className="btn-icon"
                  type="button"
                  onClick={() => setOpenKolektor(true)}
                >
                  <MdPersonSearch /> Pilih
                </Button>
                {selectedKolektor && (
                  <Button
                    className="btn-icon"
                    type="button"
                    variant="outline-secondary"
                    onClick={clearKolektorFilter}
                  >
                    <MdClose /> Hapus Filter
                  </Button>
                )}
              </div>
            </Form.Group>
          </Col>
        </Row>
        <Form onSubmit={searchData}>
          <div className="search-row mt-0">
            <SearchBar value={query} setSearchTerm={setQuery} />
            <Button type="submit">Cari</Button>
          </div>
        </Form>
      </section>
      <ShowTableDaftarKunjungan currentPosts={daftarKunjungansData} />
      <div className="search-row">
        <Pagination count={pages} page={page + 1} onChange={handleChange} color="primary" size={screenSize <= 600 ? "small" : "large"} />
      </div>
      <Dialog
        open={openKolektor}
        onClose={() => setOpenKolektor(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Pilih Kolektor</DialogTitle>
        <DialogContent>
          <Form onSubmit={searchKolektor}>
            <div className="search-row mt-0 mb-3">
              <Form.Control
                value={queryKolektor}
                placeholder="Cari kode atau nama kolektor..."
                onChange={(event) => setQueryKolektor(event.target.value)}
              />
              <Button type="submit">Cari</Button>
            </div>
          </Form>
          <TableContainer component={Paper}>
            <Table aria-label="pilih kolektor">
              <TableHead>
                <TableRow>
                  <TableCell>Kode Kolektor</TableCell>
                  <TableCell>Nama Kolektor</TableCell>
                  <TableCell>Telepon</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {!loadingKolektor &&
                  kolektors.map((kolektor) => (
                    <TableRow
                      key={kolektor._id}
                      className="row-clickable"
                      onClick={() => selectKolektor(kolektor)}
                    >
                      <TableCell>{kolektor.kodeKolektor || "-"}</TableCell>
                      <TableCell>{kolektor.namaKolektor || "-"}</TableCell>
                      <TableCell>{kolektor.teleponKolektor || "-"}</TableCell>
                    </TableRow>
                  ))}
                {!loadingKolektor && kolektors.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      Data Kolektor tidak ditemukan.
                    </TableCell>
                  </TableRow>
                )}
                {loadingKolektor && (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      Memuat data...
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <div className="search-row">
            <Pagination
              count={pagesKolektor}
              page={pageKolektor + 1}
              onChange={(event, selectedPage) =>
                setPageKolektor(selectedPage - 1)
              }
              color="primary"
              size={screenSize <= 600 ? "small" : "medium"}
            />
          </div>
        </DialogContent>
        <DialogActions>
          {selectedKolektor && (
            <Button
              variant="outline-secondary"
              type="button"
              onClick={() => {
                clearKolektorFilter();
                setOpenKolektor(false);
              }}
            >
              <MdClose /> Semua Kolektor
            </Button>
          )}
          <Button
            className="btn-back"
            variant="outline-secondary"
            type="button"
            onClick={() => setOpenKolektor(false)}
          >
            {"< Kembali"}
          </Button>
        </DialogActions>
      </Dialog>
      <ConfirmDeleteDialog show={showDeleteConfirm} message={`Yakin ingin menghapus Daftar Kunjungan ${daftarKunjunganData?.optionNamaPemohon}?`} onCancel={() => setShowDeleteConfirm(false)} onConfirm={deleteDaftarKunjungan} />
      <InfoDialog show={Boolean(deleteError)} title="Data Tidak Bisa Dihapus" message={deleteError} onClose={() => setDeleteError("")} />
    </div>
  );
};

export default TampilDaftarKunjungan;
